<template>
  <button class="loadingButton-button loadingButton-loading">
    <span class="button-contents" v-if="iconClass"><i :class="iconClass" v-if="iconClass"></i></span>
    <span class="spinner" v-else></span>
  </button>
</template>

<script>
export default {
  name: 'SpinnerButton',
  props: {
    iconClass: String,
  },
};
</script>

<style lang="scss">
.loadingButton-button {
  position: relative;
  // height: 40px;
  // width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-out;
  display: flex;
  .button-contents {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.loadingButton-loading {
  position: relative;
  border-radius: 50%;
  width: 24px;
  .spinner {
    display: block;
    width: 24px;
    height: 24px;

    // position: absolute;
    // top: calc(50% - 12px);
    // left: calc(50% - 12px);
    // background: transparent;
    box-sizing: border-box;
    border-top: 4px solid #a1a1a1;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-radius: 100%;
    animation: spin 0.6s ease-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>